import { Component } from '@angular/core';
import { SearchBaseCardComponent } from '../search-base-card.component';

@Component({
  selector: 'app-search-patient-file-card',
  standalone: false,
  
  templateUrl: './search-patient-file-card.component.html',
  styleUrl: './search-patient-file-card.component.scss'
})
export class SearchPatientFileCardComponent extends SearchBaseCardComponent {

  openInNewTab(id:number): void {
    window.open(`/file-case/${id}`, '_blank');
  }
}
